import { Topic } from '../types/Topic';

enum Filters {
    Services = 'services',
    Example = 'example'
}

type FiltersObject = {
    [key: string]: any;
    [Filters.Services]: Topic[];
    [Filters.Example]: any[];
};

const initialFilters: FiltersObject = {
    [Filters.Services]: [],
    [Filters.Example]: []
};

enum SortBy {
    Newest = 'Neuste zuerst',
    Oldest = 'Älteste zuerst'
}
type FilterOptions = {
    [key: string]: any[] | { [key: string]: any };
};

type FilterWithMaxLength = Filters.Example;

const filterOptionsMaxLengths = {
    [Filters.Example]: 3
};

// when all options of a filter or none are selected, the filters can be ignored
const noneOrAllSelected = (filters: FiltersObject, key: FilterWithMaxLength) => {
    let maxLength = filterOptionsMaxLengths[key as FilterWithMaxLength];
    return filters[key].length === maxLength || filters[key].length === 0;
};

const formatFiltersForRequest = (filters: FiltersObject) => {
    let queryOptions: FilterOptions = {
        services: [],
        example: []
    };
    for (const key in filters) {
        filters[key as Filters].map((value: any) => {
            switch (key) {
                case 'example':
                    if (!noneOrAllSelected(filters, key as FilterWithMaxLength)) {
                        queryOptions = {
                            ...queryOptions,
                            type: [...(queryOptions.type as string[]), value]
                        };
                    }
                    break;
                case 'services':
                    const topicId = (value as Topic).id.toString();
                    if (topicId !== undefined) {
                        queryOptions = {
                            ...queryOptions,
                            [key]: [...(queryOptions.topics as string[]), topicId]
                        };
                    }
                    break;

                default:
                    queryOptions = {
                        ...queryOptions,
                        [key]: [...(queryOptions[key] as string[]), value]
                    };
            }
        });
    }

    // remove possible duplicates
    const uniqueOptions = Object.entries(queryOptions)
        .map(([key, value]) => {
            return {
                // if filter is array, remove duplicates
                [key]: Array.isArray(value) ? Array.from(new Set(value)) : value
            };
        })
        .reduce((acc, curr) => ({ ...acc, ...curr }), {});
    return uniqueOptions;
};

const formatFiltersForSearchParams = (filter: FiltersObject) => {
    let filters = '';

    Object.entries(filter).forEach(([key, value]) => {
        if (value.length < 1) return;
        switch (key) {
            case Filters.Services:
                filters += `${key}:${value.map((topic: Topic) => topic.id).join(',')}+`;
                break;

            default:
                filters += `${key}:${value.join(',')}+`;
                break;
        }
    });

    const filterParams = new URLSearchParams();

    // remove last '+'
    filterParams.append('filters', filters.slice(0, -1));
    return filterParams.toString();
};

const parseFiltersFromSearchParams = (
    searchParams: URLSearchParams,
    topics: Topic[]
): FiltersObject => {
    const filterQuery = searchParams.get('filters');

    if (!filterQuery || filterQuery === '') {
        return initialFilters;
    }

    const parsedFilters: Partial<FiltersObject> = Object.assign({}, initialFilters);

    filterQuery.split('+').forEach((filter) => {
        const key = filter.split(':')[0];
        const values = filter.split(':')[1].split(',');

        switch (key) {
            case Filters.Services:
                parsedFilters[key] = topics.filter((topic) => values.includes(topic.id.toString()));
                break;

            default:
                parsedFilters[key] = values;
                break;
        }
    });
    // Merge the parsed filters into the initial filters
    return { ...initialFilters, ...parsedFilters };
};

export {
    formatFiltersForRequest,
    formatFiltersForSearchParams,
    parseFiltersFromSearchParams,
    initialFilters
};
export { Filters, SortBy };
export type { FiltersObject, FilterOptions };
